import http from './http';
import {ME_BASE} from './paths';

// 내 메뉴 트리 (권한 필터된)
export const getMyMenus = async () => {
  const res = await http.get(`${ME_BASE}/menus`);
  return res.data; // { code, data: MyMenuDto[] }
};

// 내 API 권한 목록 (읽기/실행)
export const getMyApis = async () => {
  const res = await http.get(`${ME_BASE}/apis`);
  return res.data; // { code, data: ApiPermissionDto[] }
};

// 내 API 캐시 리프레시
export const refreshMyApiCache = async () => {
  const res = await http.post(`${ME_BASE}/apis/cache/refresh`);
  return res.data; // { code, message }
};

// 내 메뉴 캐시 리프레시
export const refreshMyMenuCache = async () => {
  const res = await http.post(`${ME_BASE}/menus/cache/refresh`);
  return res.data; // { code, message }
};

// 전체 사용자 메뉴 캐시 무효화 (관리자용)
export const invalidateAllMenuCache = async () => {
  const res = await http.post(`${ME_BASE}/menus/cache/invalidate`);
  return res.data; // { code, message }
};
